import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type MySalesState = {
  page: number;
  perPage: number;
  filters: Record<string, any>;
  editModalFocusField: string | null;
};

const initialState: MySalesState = {
  page: 1,
  perPage: 24,
  filters: {
    auctionStatus: 'active',
    auctionType: 'autoaxess'
  },
  editModalFocusField: null
};

const mySalesSlice = createSlice({
  name: 'mySales',
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setFilters(state, action: PayloadAction<Record<string, any>>) {
      state.filters = action.payload;
    },
    setStatusFilter(state, action: PayloadAction<string>) {
      if (action.payload === '') {
        delete state.filters.status;
      } else {
        state.filters.status = action.payload;
      }

      state.page = 1;
    },
    setSearchFilter(state, action: PayloadAction<string>) {
      if (action.payload === '') {
        delete state.filters.search;
      } else {
        state.filters.search = action.payload;
      }

      state.page = 1;
    },
    setAuctionTypeFilter(state, action: PayloadAction<string>) {
      state.filters.auctionType = action.payload;
      state.page = 1;
    },
    setFocusField(state, action: PayloadAction<string | null>) {
      state.editModalFocusField = action.payload;
    },
    resetFilters(state) {
      state.page = 1;
      state.perPage = 24;
      state.filters = {
        auctionStatus: 'active',
        auctionType: 'autoaxess'
      };
    }
  }
});

export const {
  setPage,
  setFilters,
  setFocusField,
  setStatusFilter,
  resetFilters,
  setSearchFilter,
  setAuctionTypeFilter
} = mySalesSlice.actions;
export default mySalesSlice;
